import { graphql, commitMutation } from 'react-relay';

const mutation = graphql`
    mutation RenderInvoiceEmailMutation($input: RenderInvoiceEmailInput!) {
        renderInvoiceEmail(input: $input) {
            clientMutationId
        }
    }
`;

const commit = (environment, args) => {
    const {
        message,
        recipientEmails,
        senderEmail,
        senderName,
        transactionId,
        onCompleted,
        onError,
    } = args;

    const input = { message, recipientEmails, senderEmail, senderName, transactionId };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
        },
        onCompleted,
        onError,
    });
};

export default { commit };
